import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const discoverEmersonContent = css`
  padding-right: 2.5rem;
  @media (max-width: ${dimensions.phoneLargeMax}) {
    padding-bottom: 2.5rem;
    padding-right: 0;
  }
`;

export const video = css`
  width: 100%;
  height: 25rem;
  border-radius: ${dimensions.cardRadius};
  @media (max-width: ${dimensions.phoneLargeMax}) {
    padding-left: 0;
    width: 100%;
    min-height: 30rem;
    height: 100%;
  }
`;

export const centered = css`
  justify-content: center;
`;
